// Projects data.
// Note: Here we are getting data from a js file, but in a different project I'll be fetching these projects from some srt of APIs.

const projects = [
	{
		id: 15,
		title: 'Hoa Tieu Tan Cang Website',
		category: 'Freelance Project',
		img: require('@/assets/images/project-15.png'),
		isFeature: true
	},
	{
		id: 14,
		title: 'AI Chat Application',
		category: 'Freelance Project',
		img: require('@/assets/images/project-14.png'),
		isFeature: true
	},
	{
		id: 13,
		title: 'Mastweet - Social Media Application',
		category: 'Freelance Project',
		img: require('@/assets/images/project-13.png'),
		isFeature: true
	},
	{
		id: 12,
		title: 'Car Control Application',
		category: 'Freelance Project',
		img: require('@/assets/images/project-12.png'),
		isFeature: true
	},
	{
		id: 11,
		title: '5 Phut Thuoc Bai - Landing Page',
		category: 'Freelance Project',
		img: require('@/assets/images/project-11.png'),
		isFeature: false
	},
	{
		id: 10,
		title: 'Vacuum Robot Control Application',
		category: 'Freelance Project',
		img: require('@/assets/images/project-10.png'),
		isFeature: true
	},
	{
		id: 9,
		title: 'NFT Marketplace Web/App',
		category: 'Freelance Project',
		img: require('@/assets/images/project-9.png'),
		isFeature: true
	},
	{
		id: 8,
		title: 'Luar - Plant Social Club',
		category: 'Personal Project',
		img: require('@/assets/images/project-8.png'),
		isFeature: false
	},
	{
		id: 7,
		title: 'Clean Up - Clean Phone Storage Application',
		category: 'Freelance Project',
		img: require('@/assets/images/project-7.png'),
		isFeature: false
	},
	{
		id: 6,
		title: 'Behap Website',
		category: 'Freelance Project',
		img: require('@/assets/images/project-6.png'),
		isFeature: false
	},
	{
		id: 5,
		title: 'GoxGreen Web/App',
		category: 'Freelance Project',
		img: require('@/assets/images/project-5.png'),
		isFeature: false
	},
	{
		id: 4,
		title: 'Prudential Internal Projects',
		category: 'Business Product',
		img: require('@/assets/images/project-4.png'),
		isFeature: false
	},
	{
		id: 3,
		title: 'Ethereum Web/App',
		category: 'Business Product',
		img: require('@/assets/images/project-3.png'),
		isFeature: false
	},
	{
		id: 2,
		title: 'T-shirt',
		category: 'Business Product',
		img: require('@/assets/images/project-2.png'),
		isFeature: false
	},
	{
		id: 1,
		title: 'SKG Landing Page',
		category: 'Business Product',
		img: require('@/assets/images/project-1.png'),
		isFeature: false
	}
];

export default projects;
